export const darkTheme = {
  body: "#000000",
  text: "#ffffff",
  authTitle: {
    subtitle: "#808D9F",
  },
  input: {
    border: "#21262F",
    bg: "#121212",
    label: "#fff",
    text: "#ffffff",
  },
  alert: {
    text: "#808D9F",
  },
  logButton: {
    border: "#24ff00",
    text: "#24ff00",
  },
  activate: {
    border: "#3E3E3E",
    inputBorder: "#21262F",
  },
  image: 1,
  logo: "/assets/app_logo_dark.png",
  cong: "/assets/cong_dark.png",
};
